import React from 'react';
import styled from '@emotion/styled';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import { designSystem } from '@/styles/theme';

/**
 * 목록 위 "‘검색어’ 검색 결과 [검색 취소]" 띠 — 속닥속닥·전문가 라운지 공용(2026-10-11, 전문가 라운지 띠를 옮김).
 * 앞 기호는 글자 이모지(🔍·👤) 대신 SVG 아이콘(가이드 4.1), [검색 취소]는 누름 영역 44px.
 */
const Banner = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 44px;
    margin: 12px 0;
    padding: 0 4px 0 14px;
    box-sizing: border-box;
    background: ${designSystem.colors.primaryLight};
    border: 1px solid ${designSystem.colors.primaryLight};
    border-radius: 8px;
    font-size: 14px;
    color: ${designSystem.colors.primaryDark};
    word-break: keep-all;

    svg {
        display: block;
        flex-shrink: 0;
        width: 18px;
        height: 18px;
    }
`;

const Label = styled.span`
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const CancelButton = styled.button`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 44px;
    margin-left: auto;
    padding: 0 10px;
    background: none;
    border: none;
    color: ${designSystem.colors.primary};
    cursor: pointer;
    font-family: inherit;
    font-size: 13px;
    font-weight: 600;

    &:hover { text-decoration: underline; }
`;

export interface SearchResultBannerProps {
    /** 띠 글 — 검색어면 `‘검색어’ 검색 결과` 를 만들어 준다 */
    keyword?: string;
    /** 검색어가 아닌 띠(예: 특정 작성자의 글만 보고 있습니다) */
    children?: React.ReactNode;
    icon?: 'search' | 'person';
    cancelLabel?: string;
    onCancel: () => void;
}

const SearchResultBanner: React.FC<SearchResultBannerProps> = ({ keyword, children, icon = 'search', cancelLabel = '검색 취소', onCancel }) => (
    <Banner role="status">
        {icon === 'person' ? <PersonOutlineRoundedIcon aria-hidden="true" /> : <SearchRoundedIcon aria-hidden="true" />}
        <Label>
            {keyword != null ? <>‘<strong>{keyword}</strong>’ 검색 결과</> : children}
        </Label>
        <CancelButton type="button" onClick={onCancel}>{cancelLabel}</CancelButton>
    </Banner>
);

export default SearchResultBanner;
